import { Component, Vue, Prop } from 'vue-property-decorator';
import { VueConstructor, CreateElement, VNodeData, VNode } from 'vue';
import ClToolbar from '../ClToolbar/ClToolbar';

@Component({
  components: { ClToolbar }
})
export default class ClDialogActions extends Vue {
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  @Prop({
    type: [String, Function],
    default: 'cl-toolbar'
  })
  public component!: string | VueConstructor<Vue>;

  render(h: CreateElement): VNode {
    const componentData: VNodeData = {
      class: {
        'cl-dialog-actions': true
      }
    };
    return h(this.component, componentData, this.$slots.default);
  }
}
